module.exports = __webpack_public_path__ + "static/1inch-6e1154ae8fb1f7c2e420a70592d50dd9.png";